import Vue from "vue";
import { Component } from "vue-property-decorator";
import { locationRepository } from "@/repositories";
import { ILocation } from "@/models";
import { FileNames } from "@/enums";

@Component({
    name: "location",
    metaInfo: {
        title: "Location",
    },
})

export default class Location extends Vue {

    public loading: boolean = false;
    public loadingButton: boolean = false;

    public headers = [
        { text: "Name", value: "name", class: "nowrap", cellClass: "fixedHeight", sortable: true },
        { text: "Address", value: "address", class: "nowrap", cellClass: "fixedHeight", sortable: true },
        { text: "PostalCode", value: "postalCode", class: "nowrap", cellClass: "fixedHeight", sortable: true },
        { text: "City", value: "city", class: "nowrap", cellClass: "fixedHeight", sortable: true },
        { text: "Region", value: "region", class: "nowrap", cellClass: "fixedHeight", sortable: true },
        { text: "Country", value: "country", class: "nowrap", cellClass: "fixedHeight", sortable: true },
        { text: "Country Code", value: "countryCode", class: "nowrap", cellClass: "fixedHeight", sortable: true },
    ];

    public search = "";

    public fields: ILocation[] = [];

    get itemsPerPage(): number{
        return this.$store.getters["app/itemsPerPage"];
    }

    async mounted(): Promise<void> {
        this.loading = true;
        locationRepository.getAllWithRequestsNumber().then(res=> {
            this.fields = res;
            this.loading = false;
        }).catch (error => {
            this.loading = false;
            this.$emit("error", error);
        });
    }

    public handleItemsPerPage(itemsPerPage: number): void{
        this.$store.dispatch("app/updateItemsPerPage", itemsPerPage);
    }

    public async exportData(): Promise<void> {
        this.loadingButton = true;
        locationRepository.export("export").then(res=> {
            const url = window.URL.createObjectURL(new Blob([res.data]))
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', FileNames.Location)
            document.body.appendChild(link);
            link.click();
            this.loadingButton = false;
        }).catch (error => {
            this.$emit("error", error);
        });
    }
}
